import React from 'react'
import AdminUsers from '../../components/AdminUsers/AdminUsers'

function AdminUsersPage() {
  return (
    <AdminUsers />
  )
}

export default AdminUsersPage